import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { getTCardMovementHistory_GET } from '../../../../Core/Service/checkInRole';
import './tCardStyle.scss';

const HistoryTableModal = ({ tCardsID }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!tCardsID) return;

        const controller = new AbortController();
        const fetchData = async () => {
            try {
                const rec = await getTCardMovementHistory_GET(tCardsID, { signal: controller.signal });
                if (rec.success) {
                    setHistory(rec.data?.tCardStatusMovementHistory || []);
                } else {
                    console.error('API response unsuccessful:', rec);
                    setHistory([]);
                }
            } catch (error) {
                if (error.name !== 'AbortError') {
                    console.error('Error fetching history:', error);
                    setHistory([]);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        return () => controller.abort();
    }, [tCardsID]);

    return (
        <div className="table-container" style={{ height: 'calc(100vh - 630px)', border: '1px solid rgba(0,0,0,0.2)', overflow: 'auto' }}>
            <table className="history-table">
                <thead>
                    <tr>
                        <th>Status</th>
                        <th>Added</th>
                        <th>Completed</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={3} align="center">
                                Loading...
                            </td>
                        </tr>
                    ) : history.length === 0 ? (
                        <tr>
                            <td colSpan={3} align="center">
                                No record found.
                            </td>
                        </tr>
                    ) : (
                        history.map((item, i) => <HistoryTableRow key={i} item={item} />)
                    )}
                </tbody>
            </table>
        </div>
    );
};

const formatDate = (date) => (date ? moment(date).format('LLL') : 'N/A');

const HistoryTableRow = ({ item }) => (
    <tr>
        <td>{item.status}</td>
        <td>
            {item.createdBy && item.tCardMovementCreatedAt
                ? `${item.createdBy} @ ${formatDate(item.tCardMovementCreatedAt)}`
                : item.createdBy || formatDate(item.tCardMovementCreatedAt)}
        </td>
        <td>
            {item.movedBy && item.tCardMovementMovedAt
                ? `${item.movedBy} @ ${formatDate(item.tCardMovementMovedAt)}`
                : item.movedBy || formatDate(item.tCardMovementMovedAt)}
        </td>
    </tr>
);

export default HistoryTableModal;
